<template>
  <div class="tr-origin" :class="`tr-origin-${type}`">
    <div class="tr-origin-head">
      <fa-icon class="tr-origin-icon" :icon="['fal', icon]"/>
      <span class="tr-origin-title">
        {{ title }}
        <span class="label label-rounded" v-if="count > 0">{{ count }}</span>
      </span>
      <span class="tr-origin-sub">{{ subtitle }}</span>
      <span class="tr-origin-total" v-if="count > 0">
        <template v-if="pending > 0">
          Pendente <b>{{ pending | currency }}</b>
        </template>
        <template v-if="pending > 0 && (payable > 0 || paid > 0)"> · </template>
        <template v-if="payable > 0">
          A pagar <b>{{ payable | currency }}</b>
        </template>
        <template v-if="paid > 0">
          <template v-if="pending > 0 || payable > 0"> · </template>
          pago <span class="text-green">{{ paid | currency }}</span>
        </template>
      </span>
    </div>
    <div class="tr-origin-empty" v-if="count === 0">
      <fa-icon class="tr-origin-empty-icon" :icon="['fal', 'check-circle']"/>{{ emptyText }}
    </div>
    <div class="cr-table-scroll" v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {
  origins, descriptions, icons, emptyTexts,
} from '@/data/billing-transfer-origins';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    pending: {
      type: Number,
      default: 0,
    },
    payable: {
      type: Number,
      default: 0,
    },
    paid: {
      type: Number,
      default: 0,
    },
    customTitle: {
      type: String,
      default: null,
    },
    customSubtitle: {
      type: String,
      default: null,
    },
    customEmpty: {
      type: String,
      default: null,
    },
  },
  computed: {
    title() {
      return this.customTitle || origins[this.type] || this.type;
    },
    subtitle() {
      return this.customSubtitle || descriptions[this.type] || '';
    },
    icon() {
      return icons[this.type] || 'file-invoice-dollar';
    },
    emptyText() {
      return this.customEmpty || emptyTexts[this.type] || 'Nenhum item no período.';
    },
  },
};
</script>
